import { createContext, useContext } from 'react';

const ConnectionContext = createContext(undefined);

export function ConnectionProvider({ value, children }) {
  return <ConnectionContext.Provider value={value}>{children}</ConnectionContext.Provider>;
}

export function useConnectionContext() {
  const ctx = useContext(ConnectionContext);
  if (ctx === undefined) {
    throw new Error('useConnectionContext must be used within a ConnectionProvider');
  }
  return ctx;
}
